import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {NzMessageService, NzTableQueryParams} from 'ng-zorro-antd';
import { STColumn, STData, STChange, STComponent } from '@delon/abc';
import {  ModalHelper, DrawerHelper } from '@delon/theme';
import { SFSchema } from '@delon/form';
import {Router} from "@angular/router";
import { DynamicComponentGridFormService } from './service/dynamic-component-grid-form.service';
import { DynamicCol } from '../common/dynamic-col';
import { DynamicComponentGridFormGetMetaInfoParameter, DynamicComponentGridFormGetMetaInfoRequest, DynamicComponentGridFormUpdateRequest, DynamicComponentGridFormGetMetaInfoTool } from './service/model/models';
import { DynamicComponentGridFormGetMetaInfoForm } from './service/model/dynamicComponentGridFormGetMetaInfoForm';
import { DynamicTool } from '../common/dynamic-tool';
import { DynamicComponentGridFormGetPageRequest } from './service/model/dynamicComponentGridFormGetPageRequest';
import { DynamicComponentGridFormGetTotalRequest } from './service/model/dynamicComponentGridFormGetTotalRequest';
import { LcImportFormComponent } from '../lc-import-form/lc-import-form.component';
import { LcEditFormComponent } from '../lc-edit-form/lc-edit-form.component';
import { LcDetailFormComponent } from '../lc-detail-form/lc-detail-form.component';
import { CacheService } from '@delon/cache';
import { DA_SERVICE_TOKEN, ITokenService, TokenService } from '@delon/auth';
@Component({
  selector: 'lc-grid-form',
  templateUrl: './lc-grid-form.component.html',
  styleUrls: ['./lc-grid-form.component.css'],
//   changeDetection: ChangeDetectionStrategy.OnPush,
    providers:[DynamicComponentGridFormService]
})
export class LcGridFormComponent implements AfterViewInit,OnInit {
    parentModel:any;
    @Input()
    parentId:any;
    _windowFormId: string;
    @Input()
    set windowFormId(value: string) {
        this._windowFormId = value;
        if (this._windowFormId) {
            this.load();
        }
    }

    get windowFormId() {
        return this._windowFormId;
    }

    formData: any = {};
    parameter: any = {};
    dataSource: any[] = []; // 数据源
    cols: DynamicCol[] = null;
    formParameters: DynamicComponentGridFormGetMetaInfoParameter[] = [];
    checkList: STData[] = [];
    searchSchema: SFSchema = {
        properties: {
            keyword: {type: 'string', title: '名称/编码'},
        },
    };
    /**
     * 窗体信息
     */
    form: DynamicComponentGridFormGetMetaInfoForm = {};
    /**
     * 工具栏信息
     */
    tools: DynamicComponentGridFormGetMetaInfoTool[] = [];
    /**
     * 表格操作
     */
    gridTools: DynamicComponentGridFormGetMetaInfoTool[] = [];
    pageSize = 50;
    pageIndex = 1;
    /**
     * 总数量
     */
    total: any = 200;
    isCollapse = false;
    scrollX=0;
    scrollY='240';

    get parameterSpan() {
        return 24 / (this.form.layoutCol|4)
    }

    constructor(
        private msg: NzMessageService,
        private modal: ModalHelper,
        private router: Router,
        private service: DynamicComponentGridFormService,
        private cd: ChangeDetectorRef,
        private drawer: DrawerHelper,
        @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,

    ) {
    }

    /**
     * 加载元数据
     */
    async load() {
        this.cols = [];
        const request: DynamicComponentGridFormGetMetaInfoRequest = {};
        request.id = this.windowFormId;
        const res = await this.service.getMetaInfo(request,{isCache:true});
        this.form = res.data.form;
        this.scrollX=100;
        this.scrollY=this.form.height?this.form.height:this.scrollY;
        console.log(this.scrollY)
        res.data.cols.forEach((value, index) => {
            if (!value.hidden) {
               const width=value.width || 100;
               this.scrollX+=width;
                this.cols.push({title: value.name, colName: value.colKey|| value.colName,colDataType: value.colDataType, width: width,formatScript:value.formatScript});
            }
        });
        res.data.tools.forEach((value, index) => {
            if (value.layoutComponentType === 0) {
                this.tools.push(value);
            } else if (value.layoutComponentType === 1) {
                this.gridTools.push(value);
            }
        })
        this.formParameters = [...res.data.parameters];
        this.toggleCollapse();
        this.cd.detectChanges();
        this.search();
    }

    toggleCollapse(): void {
        this.isCollapse = !this.isCollapse;
        this.formParameters.filter((f)=>!f.hidden).forEach((c, index) => {
            c.show = this.isCollapse ? index < 6 : true;
        });
        this.formParameters = [...this.formParameters ];
        this.cd.detectChanges();
        console.log(this.formParameters);
    }

    resetForm() {
        this.parameter = {};
    }

    search() {
        this.pageIndex = 1;
        this.getPage(this.pageIndex, this.pageSize);
    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        // this.st.load(1);
    }

    updateClick(toolItem: DynamicComponentGridFormGetMetaInfoTool,i: any) {
        if(!i.id){
            this.msg.error('id为空,请联系管理员');
            return;
        }
        const request:DynamicComponentGridFormUpdateRequest={};
        request.windowFormToolId=toolItem.devWindowFormToolId;
        request.id=i.id;
        this.service.update(request).then(res=>{
            if (res.code === 1) {
                this.msg.success('Success');
                this.search();
            } else {
                this.msg.error(res.message);
            }
        });
    }

    view(rowData: any) {
        this.router.navigateByUrl(`/dev/window/detail/${rowData.id}`);
    }
    /**
     * 按钮是否显示
     * @param toolItem 
     * @param item 
     */
    doIf(toolItem:DynamicComponentGridFormGetMetaInfoTool,item){
        if(toolItem.ifScript){
       return new Function('toolItem','item',toolItem.ifScript)(toolItem,item);
        }

        return true;
    }
    doColFormat(item: any, col: DynamicCol, index: number){
        if(col.formatScript){
            return new Function('item','col','index',col.formatScript)(item,col,index);
        }
        switch (col.colDataType) {
            case 'tinyint': return item[col.colName]?'是':'否';
            case 'datetime': break;
            default: break;
        }
        return item[col.colName];

    }
    doOnClick(toolItem: DynamicComponentGridFormGetMetaInfoTool, i?: any) {
        console.log(toolItem);
        switch(toolItem.windowFormToolType){
            case 0:    //打开窗体
                       this.modal.create(LcEditFormComponent, {
                        windowFormId: toolItem.popWindowFormId,
                        parentModel:this.parentModel,
                        parentId:this.parentId,
                        id:i?i.id:null
                        }, {size: 'lg'}).subscribe(() =>  this.getPage(this.pageIndex, this.pageSize));
                       break;
            case 101: //更新
                       this.updateClick(toolItem,i);
                       break;           
            case 102: //导入
                        this.modal.create(LcImportFormComponent, {
                            windowFormId: toolItem.popWindowFormId,
                        }, {size: 'lg'}).subscribe(() => this.search());
                      break;  
            case 103: //导出
                        const queryParam: any = this.getQueryParam();
                       this.service.exportExcel(queryParam,toolItem.popWindowFormId)
                      break;   
            case 104: //详情
                        this.drawer
                        .create(`详情`, LcDetailFormComponent, {id:i.id,windowFormId:toolItem.popWindowFormId}, {size: 1200})
                        .subscribe(null);
                        break;                      
        }
    }

    change(params: NzTableQueryParams): void {
        console.log(params);
        const {pageSize, pageIndex, sort, filter} = params;
        const currentSort = sort.find(item => item.value !== null);
        const sortField = (currentSort && currentSort.key) || null;
        const sortOrder = (currentSort && currentSort.value) || null;
        this.getPage(pageIndex, pageSize);
    }

    /**
     *查询当前页数据
     *
     * @param {*} pageIndex
     * @param {*} pageSize
     * @memberof UsersComponent
     */
    getPage(pageIndex, pageSize) {
        if(!this.windowFormId) return;
        const request: DynamicComponentGridFormGetPageRequest = {queryParam: {}, pageParam: {}};
        request.pageParam.pageIndex = pageIndex;
        request.pageParam.pageSize = pageSize;
        request.windowFormId=this.windowFormId;
        request.queryParam = this.getQueryParam();
        this.service.getPage(request).then(res => {
            this.dataSource = res.data;
            this.cd.detectChanges();
        });
        if (pageIndex === 1) {
            this.setTotal();
        }
    }

    /**
     * 设置总数量
     *
     * @memberof UsersComponent
     */
    setTotal() {
        const requestTotal: DynamicComponentGridFormGetTotalRequest = {queryParam: {}};
        requestTotal.windowFormId=this.windowFormId;
        requestTotal.queryParam = this.getQueryParam();
        this.service.getTotal(requestTotal).then(res => {
            this.total = res.total;
            this.cd.detectChanges();
        });
    }

    getQueryParam() {
        //格式化参数
        this.formartParemeter();
        return {...this.parameter};
    }
    visible = false;

    open(): void {
        this.visible = true;
    }

    close(): void {
        this.visible = false;
    }
    private formartParemeter(){
        //格式化参数
        this.formParameters.forEach(f=>{
            if(f.formatScript) {
                const user=this.tokenService.get();
                const value= new Function('user','parameter','parentModel','parentId','that',f.formatScript)(user,this.parameter,this.parentModel,this.parentId,this);
                if(value!=null){
                    this.parameter[f.pmKey]=value;
                }
            }
        });
    }
}
